import bi from 'shared/bi/bi';

import { getAllSettings } from 'shared/selectors/app-settings';
import { getChannelForWidget } from '@wix/wix-vod-shared/dist/src/common/selectors/channels';
import { getMainVideoId } from '@wix/wix-vod-shared/dist/src/widget/ui-selectors/selected-video-id';
import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { getVideoSelectedEventParams } from 'shared/utils/bi/video-overlay-events-params';

import { SELECTED_VIDEO_ACTIONS } from 'widget/redux/client/actions/select-video';

export default {
  [SELECTED_VIDEO_ACTIONS.SET]: ({ state, action, previousState }) => {
    if (action.payload === previousState.selectedVideoId) {
      return;
    }

    bi.log(
      'widget.VidSelected.displayed',
      getVideoSelectedEventParams({
        appSettings: getAllSettings(state),
        channelData: getChannelForWidget(state),
        videoItem: getVideosGroupedByIds(state)[getMainVideoId(state)],
      }),
    );
  },
};
